<template>
  <div v-if="exibir" id="chatAjudaDourasat">
    <q-card
      v-if="iframeCriado"
      v-show="aberto"
      class="chat-ajuda-painel"
      :class="{ 'chat-ajuda-painel--tela-cheia': $q.screen.lt.sm }"
      :style="$q.screen.lt.sm ? null : posicao"
    >
      <q-btn
        class="chat-ajuda-fechar"
        flat
        round
        dense
        icon="close"
        aria-label="Fechar assistente"
        @click="aberto = false"
      />
      <iframe
        ref="frame"
        class="chat-ajuda-frame"
        :src="urlFrame"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
        referrerpolicy="no-referrer"
        title="Assistente virtual DouraSoft"
      />
    </q-card>

    <q-btn
      v-show="!(aberto && $q.screen.lt.sm)"
      id="btnChatAjuda"
      round
      color="primary"
      class="chat-ajuda-botao"
      :style="posicao"
      aria-label="Assistente virtual"
      @click="alternar"
    >
      <q-icon size="32px" name="smart_toy" />
    </q-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// O widget do DouraSat roda numa página de outra origem, nunca na do app: o token de sessão
// fica no localStorage do app e não pode ficar ao alcance de script de terceiro. A origem da
// API também não serve, porque nela vive a área interna com cookie de sessão; por isso cada
// ambiente tem um domínio só para a página. Endereço fora da lista não mostra o assistente.
const ORIGENS_PAGINA_ISOLADA = {
  "app.dourasoft.net": "https://chat.dourasoft.net",
  "dev-app.dourasoft.net": "https://dev-chat.dourasoft.net",
};

export function origemApi() {
  try {
    return new URL(process.env.VUE_APP_URL_API).origin;
  } catch (e) {
    return "";
  }
}

export function origemPaginaIsolada(hostApp = window.location.hostname) {
  if (hostApp === "localhost") return origemApi();

  return ORIGENS_PAGINA_ISOLADA[hostApp] || "";
}

export function urlPaginaIsolada() {
  return `${origemPaginaIsolada()}/chat-ajuda.html`;
}

export default {
  name: "chat-ajuda-dourasat",
  // Largura atual do menu lateral (recolhido ~57px, fixado 250px) vem do QLayout.
  // O Quasar 2 não provê mais pelo nome `layout`: a chave é `layoutKey`
  // (quasar/src/utils/private.symbols/symbols.js), que o pacote não exporta. Sem o
  // `from`, o inject cai no default e o botão fica por baixo do menu.
  inject: { layout: { from: "_q_l_", default: null } },
  data() {
    return {
      aberto: false,
      iframeCriado: false,
    };
  },
  computed: {
    ...mapGetters(["chatAjudaWidget", "dataEmpresa"]),
    exibir() {
      if (!this.chatAjudaWidget || !origemPaginaIsolada()) return false;

      return !(this.$q.screen.lt.sm && this.$route.name === "resumo_tfl");
    },
    urlFrame() {
      return urlPaginaIsolada();
    },
    posicao() {
      const menu = this.layout && this.layout.left;
      const ocupado = menu && menu.space ? menu.size : 0;

      return { left: `${ocupado + 20}px` };
    },
  },
  watch: {
    "dataEmpresa.id": {
      immediate: true,
      handler(id) {
        if (id) this.$store.dispatch("buscarWidgetChatAjuda");
      },
    },
  },
  mounted() {
    window.addEventListener("message", this.receberMensagem);
  },
  beforeUnmount() {
    window.removeEventListener("message", this.receberMensagem);
  },
  methods: {
    alternar() {
      this.iframeCriado = true;
      this.aberto = !this.aberto;
    },
    receberMensagem(evento) {
      const frame = this.$refs.frame;
      if (!frame || evento.source !== frame.contentWindow) return;
      if (evento.origin !== origemPaginaIsolada()) return;
      if (!evento.data || evento.data.tipo !== "chat-ajuda:carregado") return;

      const w = this.chatAjudaWidget;
      if (!w) return;

      frame.contentWindow.postMessage(
        { tipo: "chat-ajuda:visitante", config_id: w.config_id, agente: w.agente, visitor: w.visitor, data: w.data },
        origemPaginaIsolada()
      );
    },
  },
};
</script>

<style scoped>
.chat-ajuda-botao {
  position: fixed;
  bottom: 20px;
  width: 60px;
  height: 60px;
  z-index: 6000;
}
.chat-ajuda-painel {
  position: fixed;
  bottom: 92px;
  width: 380px;
  height: 560px;
  max-height: calc(100vh - 110px);
  overflow: hidden;
  border-radius: 14px;
  z-index: 6000;
}
.chat-ajuda-painel--tela-cheia {
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  max-height: none;
  border-radius: 0;
}
.chat-ajuda-frame {
  width: 100%;
  height: 100%;
  border: 0;
}
.chat-ajuda-fechar {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}
</style>
